export const LIST_NOTIFICATION_TEMPLATE = 'LIST_NOTIFICATION_TEMPLATE'
export const CREATE_NOTIFICATION_TEMPLATE = 'CREATE_NOTIFICATION_TEMPLATE'
export const REMOVE_NOTIFICATION_TEMPLATE = 'REMOVE_NOTIFICATION_TEMPLATE'
export const DETAIL_NOTIFICATION_TEMPLATE = 'DETAIL_NOTIFICATION_TEMPLATE'
